import React from 'react';

import { t } from '../../services/i18nService';
import fileDeliveryService from '../../services/FileDeliveryService';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';
import navigationService from '../../services/NavigationService';

import styles from './options.scss';

class OptionsFileDelivery extends React.Component {
    render() {
        const fileDeliveredText = `<h3>${t('options.fileDelivered')}</h3>`;
        const contentChildren = (
            <p>
                {t('options.fileDeliveredText', { fileName: fileDeliveryService.getFileName() })}
            </p>
        );

        const mainButtonText = t('options.exitSebButtonText');

        return (
            <div className={styles.fileDelivered}>
                <OptionsTopBar title={t('options.fileDelivery')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    <Confirmation
                        contentChildren={contentChildren}
                        text={fileDeliveredText}
                        mainButtonText={mainButtonText}
                        actionHandler={navigationService.exitSeb}
                        hideCancelButton
                    />
                </div>
            </div>
        );
    }
}

export default OptionsFileDelivery;
